// TextField — thin wrapper over MUI TextField (behavior/a11y) with PCS
// defaults: small, full width, outlined, validate-on-blur friendly via the
// error/helperText pair. Components pass camelCase values; wire mapping happens
// in slices, not here.
import PropTypes from 'prop-types';
import MuiTextField from '@mui/material/TextField';

export function TextField({
  label,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  required = false,
  type = 'text',
  multiline = false,
  rows,
  fullWidth = true,
  disabled = false,
  placeholder,
  ...rest
}) {
  return (
    <MuiTextField
      label={label}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      error={!!error}
      helperText={error || helperText}
      required={required}
      type={type}
      multiline={multiline}
      rows={rows}
      fullWidth={fullWidth}
      disabled={disabled}
      placeholder={placeholder}
      size="small"
      variant="outlined"
      {...rest}
    />
  );
}

TextField.propTypes = {
  label: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  /** Error message; truthy also flips the field into the error state. */
  error: PropTypes.node,
  helperText: PropTypes.node,
  required: PropTypes.bool,
  type: PropTypes.string,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
};

export default TextField;
